import React from "react";
import AdmChatBot from "../../components/AdminTabs/AdminChatBot/AdmChatBot";

const AdminChatBot = () => {
  return (
    <div>
      <AdmChatBot />
    </div>
  );
};

export default AdminChatBot;
